import { Box } from "@mui/system";
import React from "react";
import CircleIcon from "@mui/icons-material/Circle";
import DataTable from "../../Components/Data-Table";
import Container from "@mui/material/Container";
const columns = [
  {
    field: "id",
    hide: true,
  },
  {
    field: "ID",
    headerName: "No",
    width: 100,
  },
  {
    field: "Subject",
    headerName: "Subject",
    width: 400,
    editable: false,
  },
  {
    field: "Time",
    headerName: "Time",
    width: 300,
    editable: false,
  },
  {
    field: "status",
    headerName: "Status",
    width: 300,
    editable: false,
  },
];
const data = [
  {
    id: "1",
    ID: "1",
    Subject: "Washing machine has finished the task",
    Time: "01:24 PM on 5th July 2022 ",
    status: "Seen",
  },
  {
    id: "2",
    ID: "2",
    Subject: "Jacob has unlocked the main door",
    Time: "Conference Time",
    status: "Seen",
  },
  {
    id: "3",
    ID: "3",
    Subject: "All gates are closed by Mary",
    Time: "04:24 PM on 4th July 2022 ",
    status: "Seen",
  },
  {
    id: "4",
    ID: "4",
    Subject: "Projector’s lamp has reached a 40% of its lifespan",
    Time: "11:24 AM on 2nd July 2022 ",
    status: "Seen",
  },
  {
    id: "5",
    ID: "5",
    Subject: "Projector’s lamp has reached a 40% of its lifespan",
    Time: "10:59 AM on 2nd July 2022 ",
    status: "Seen",
  },
  {
    id: "6",
    ID: "6",
    Subject:
      "Air Conditioner in the living Time has been set into the Eco Mode",
    Time: "10:07 AM on 2nd July 2022 ",
    status: "Seen",
  },
  {
    id: "7",
    ID: "7",
    Subject:
      "Air Conditioner in the living Time has been set into the Eco Mode",
    Time: "10:07 AM on 2nd July 2022 ",
    status: "Seen",
  },
  {
    id: "8",
    ID: "8",
    Subject: "Mary has closed a Garage 1 door",
    Time: "10:59 AM on 2nd July 2022 ",
    status: "Seen",
  },
  {
    id: "9",
    ID: "9",
    Subject: "Power consumption has been reduced for 10% this week",
    Time: "10:07 AM on 2nd July 2022  ",
    status: "Seen",
  },
];
const status = () => {
  return (
    <Container>
      <Box sx={{ mt: 4 }}>
        <DataTable data={data} columns={columns} />
      </Box>
    </Container>
  );
};

export default status;

